import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation updateUniversityEmail($universityEmail: String!) {
    updateUniversityEmail(universityEmail: $universityEmail) {
      success
      message
    }
  }
`

export interface UpdateUniversityEmailInput {
  universityEmail: string
}

export interface UpdateUniversityEmailOutput {
  updateUniversityEmail: {
    success: boolean
    message: string
  }
}

export const useUpdateUniversityEmail = () =>
  useMutation<UpdateUniversityEmailOutput, UpdateUniversityEmailInput>(mutation)
